import {
  ScreenMediaStatus,
  ScreenMediaType,
} from '@/types/response/screenMedia';
import moment from 'moment';
import * as yup from 'yup';

export const formSchemaFn = () =>
  yup.object().shape({
    title: yup
      .string()
      .trim()
      .required('管理名は未入力です。')
      .max(100, '管理名は100文字以内で入力してください。'),
    mediaType: yup.number().required(),
    mediaUrl: yup.string().trim().required('素材は未設定です。'),
    // 動画は再生開始までの間ポスター画像を出すので、公開するなら必須。
    // サーバー側でも同じ条件で弾かれる。
    posterUrl: yup
      .string()
      .nullable()
      .when(['mediaType', 'status'], ([mediaType, status], schema) =>
        mediaType === ScreenMediaType.VIDEO &&
        status === ScreenMediaStatus.PUBLIC
          ? schema.required(
              'ポスター画像が未設定です。動画を公開するには必要です。',
            )
          : schema,
      ),
    sortOrder: yup
      .number()
      .typeError('並び順は数字で入力してください。')
      .integer('並び順は整数で入力してください。')
      .min(0, '並び順は0以上で入力してください。')
      .required('並び順は未入力です。'),
    publicAt: yup
      .date()
      .nullable()
      .when('status', ([status], schema) =>
        status === ScreenMediaStatus.PUBLIC
          ? schema.required('公開開始日時は未入力です。')
          : schema,
      ),
    publicEndAt: yup
      .date()
      .nullable()
      .test(
        'publicEndAt-after-publicAt',
        '公開終了日時は公開開始日時より後にしてください。',
        function (value) {
          const { publicAt } = this.parent;
          if (!value || !publicAt) return true;

          return moment(value).isAfter(moment(publicAt));
        },
      ),
    status: yup.number().required(),
  });
